// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* What the canvas adds to the shared top bar (GlobalPageHeader.module.css):
   pinning it over the canvas, the save state, the catalogs, and the dataflow
   title that sits under it. */

/* The canvas is a full-window surface, so the bar floats over its top edge
   instead of taking a row of the layout the way it does on a section page. */
.cf4K1VKOHC8MqfmSraso {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  /* The view switch takes about 60px of the slot; the bar's buttons give it
     back by 3px a side, so the catalogs keep their labels as long as before. */
  --curio-bar-button-padding-x: 7px;
}

/* ── Save state ──────────────────────────────────────────────────────────── */

.KH3Flkw9c5Bhta2UqYn5 {
  font-size: var(--curio-font-size-sm);
}

.TX6U0Y9BmfFv1GIAv_6v {
  color: var(--curio-top-bar-unsaved);
}

.y5vlwsQyWwpqIYABVv1x {
  color: var(--curio-top-bar-saved);
}

@keyframes ILUfFGX7Fk3P9FkuL3Om {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.4; }
}

.msv9Z7Oze4kxsS6KduGC {
  animation: ILUfFGX7Fk3P9FkuL3Om 1s ease-in-out infinite;
}

/* ── Catalogs ────────────────────────────────────────────────────────────── */

.jdK7_AwMqDCDpZHkoW4l {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

.W1_qgXYbZ1ePF9Gjrykt {
  font-size: 13px;
}

/* The labels go first when the bar runs short, and the icons stay with their
   tooltips. Queried against the header's slot rather than the window: the
   account's name is as long as the user's, so the room left over is not a
   function of the window width alone. The slot's controls need about 790px
   with every catalog label showing and the view switch as icons. */
@container (max-width: 800px) {
  .bnZn1OAjnxJIr9WJjkOw {
    display: none;
  }
}

/* ── The view switch ─────────────────────────────────────────────────────── */

/* At the slot's end, against Monitor: the auto margin takes whatever room the
   slot has left, and the bar's own gap separates it from Monitor. */
.cf4K1VKOHC8MqfmSraso .FkTfdYslsAElhtef3EVL {
  margin-left: auto;
  margin-right: 0;
}

/* ── The dataflow's title, under the bar ─────────────────────────────────── */

.lYpYYSowugJthrnu1xm0 {
  margin-top: 15px;
  text-align: center;
  z-index: 80;
  top: var(--curio-top-bar-height);
  left: 50px;
  position: fixed;
}

/* In the notebook view the cells scroll under the title: a white band behind
   it, from the window's left edge to its scrollbar and from the top bar to just
   under the chips (which hang below this box), keeps their text from showing
   through. The first cell starts lower, so the band never covers it at rest. */
.EpP1NpEEHjHd9atCpJd2::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: -15px;
  bottom: -24px;
  left: -50px;
  width: calc(100vw - 16px);
  background: #ffffff;
}

/* The catalog pages' page title (CatalogBrowseLayout.module.css \`.titleRow h1\`).
   One line, cut short with an ellipsis where it would run under the agents'
   dock on its row, as a node's title is cut in its header
   (EditableNodeHeaderLabel.module.css \`.labelText\`); the full name is its
   tooltip. The dock sets --curio-canvas-dock-left (AgentDock.tsx), whose
   default is the window's width when no dock is on the row (curioTokens.css);
   50px is where the container starts. */
.kzW0PCOT_3cK7YDXAYsP {
  font-size: 20px;
  font-weight: 700;
  color: var(--curio-text-primary);
  cursor: pointer;
  max-width: max(6em, calc(var(--curio-canvas-dock-left) - 50px - 16px));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* The category chips hang under the title without widening its container,
   so the title stays exactly where it was. */
.Y94lVqntAEssfSgWhHUu {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: -6px;
  width: max-content;
  max-width: 60vw;
  text-align: left;
}

.FjvnJsJ6pqlsJELj4_Ag {
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-sm);
  padding: 5px;
}

/* ── Read-only notice for a shared dataflow ──────────────────────────────── */

.Q30FGCd4ZhDJKuZYOw3x {
  position: absolute;
  top: calc(var(--curio-top-bar-height) + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #FFF4D6;
  color: #7A5A00;
  border: 1px solid #E6CD7A;
  border-radius: var(--curio-radius-md);
  padding: 6px 14px;
  font-size: var(--curio-font-size-sm);
  font-weight: 500;
  z-index: 1000;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/top/UpMenu.module.css"],"names":[],"mappings":"AAAA;;8BAE8B;;AAE9B;6EAC6E;AAC7E;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;+EAC6E;EAC7E,iCAAiC;AACnC;;AAEA,+EAA+E;;AAE/E;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,YAAY,YAAY,EAAE;AAC5B;;AAEA;EACE,uDAAwC;AAC1C;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;mEAImE;AACnE;EACE;IACE,aAAa;EACf;AACF;;AAEA,+EAA+E;;AAE/E;oEACoE;AACpE;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,+EAA+E;;AAE/E;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,UAAU;EACV,eAAe;AACjB;;AAEA;;;+EAG+E;AAC/E;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;;;;wCAMwC;AACxC;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,sEAAsE;EACtE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;6CAC6C;AAC7C;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,qCAAqC;EACrC,YAAY;AACd;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,qCAAqC;EACrC,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,yCAAyC;AAC3C","sourcesContent":["/* What the canvas adds to the shared top bar (GlobalPageHeader.module.css):\n   pinning it over the canvas, the save state, the catalogs, and the dataflow\n   title that sits under it. */\n\n/* The canvas is a full-window surface, so the bar floats over its top edge\n   instead of taking a row of the layout the way it does on a section page. */\n.canvasHeader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 100;\n  /* The view switch takes about 60px of the slot; the bar's buttons give it\n     back by 3px a side, so the catalogs keep their labels as long as before. */\n  --curio-bar-button-padding-x: 7px;\n}\n\n/* ── Save state ──────────────────────────────────────────────────────────── */\n\n.saveStatus {\n  font-size: var(--curio-font-size-sm);\n}\n\n.unsavedIcon {\n  color: var(--curio-top-bar-unsaved);\n}\n\n.savedIcon {\n  color: var(--curio-top-bar-saved);\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50%       { opacity: 0.4; }\n}\n\n.savingPulse {\n  animation: pulse 1s ease-in-out infinite;\n}\n\n/* ── Catalogs ────────────────────────────────────────────────────────────── */\n\n.catalogs {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n}\n\n.catalogIcon {\n  font-size: 13px;\n}\n\n/* The labels go first when the bar runs short, and the icons stay with their\n   tooltips. Queried against the header's slot rather than the window: the\n   account's name is as long as the user's, so the room left over is not a\n   function of the window width alone. The slot's controls need about 790px\n   with every catalog label showing and the view switch as icons. */\n@container (max-width: 800px) {\n  .catalogLabel {\n    display: none;\n  }\n}\n\n/* ── The view switch ─────────────────────────────────────────────────────── */\n\n/* At the slot's end, against Monitor: the auto margin takes whatever room the\n   slot has left, and the bar's own gap separates it from Monitor. */\n.canvasHeader .viewSwitch {\n  margin-left: auto;\n  margin-right: 0;\n}\n\n/* ── The dataflow's title, under the bar ─────────────────────────────────── */\n\n.workflowNameContainer {\n  margin-top: 15px;\n  text-align: center;\n  z-index: 80;\n  top: var(--curio-top-bar-height);\n  left: 50px;\n  position: fixed;\n}\n\n/* In the notebook view the cells scroll under the title: a white band behind\n   it, from the window's left edge to its scrollbar and from the top bar to just\n   under the chips (which hang below this box), keeps their text from showing\n   through. The first cell starts lower, so the band never covers it at rest. */\n.workflowNameContainerNotebook::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  top: -15px;\n  bottom: -24px;\n  left: -50px;\n  width: calc(100vw - 16px);\n  background: #ffffff;\n}\n\n/* The catalog pages' page title (CatalogBrowseLayout.module.css `.titleRow h1`).\n   One line, cut short with an ellipsis where it would run under the agents'\n   dock on its row, as a node's title is cut in its header\n   (EditableNodeHeaderLabel.module.css `.labelText`); the full name is its\n   tooltip. The dock sets --curio-canvas-dock-left (AgentDock.tsx), whose\n   default is the window's width when no dock is on the row (curioTokens.css);\n   50px is where the container starts. */\n.workflowNameStyle {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--curio-text-primary);\n  cursor: pointer;\n  max-width: max(6em, calc(var(--curio-canvas-dock-left) - 50px - 16px));\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* The category chips hang under the title without widening its container,\n   so the title stays exactly where it was. */\n.workflowCategories {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin-top: -6px;\n  width: max-content;\n  max-width: 60vw;\n  text-align: left;\n}\n\n.input {\n  font-size: 20px;\n  font-weight: 700;\n  text-align: center;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-sm);\n  padding: 5px;\n}\n\n/* ── Read-only notice for a shared dataflow ──────────────────────────────── */\n\n.sharedBanner {\n  position: absolute;\n  top: calc(var(--curio-top-bar-height) + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: #FFF4D6;\n  color: #7A5A00;\n  border: 1px solid #E6CD7A;\n  border-radius: var(--curio-radius-md);\n  padding: 6px 14px;\n  font-size: var(--curio-font-size-sm);\n  font-weight: 500;\n  z-index: 1000;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"canvasHeader": `cf4K1VKOHC8MqfmSraso`,
	"saveStatus": `KH3Flkw9c5Bhta2UqYn5`,
	"unsavedIcon": `TX6U0Y9BmfFv1GIAv_6v`,
	"savedIcon": `y5vlwsQyWwpqIYABVv1x`,
	"savingPulse": `msv9Z7Oze4kxsS6KduGC`,
	"pulse": `ILUfFGX7Fk3P9FkuL3Om`,
	"catalogs": `jdK7_AwMqDCDpZHkoW4l`,
	"catalogIcon": `W1_qgXYbZ1ePF9Gjrykt`,
	"catalogLabel": `bnZn1OAjnxJIr9WJjkOw`,
	"viewSwitch": `FkTfdYslsAElhtef3EVL`,
	"workflowNameContainer": `lYpYYSowugJthrnu1xm0`,
	"workflowNameContainerNotebook": `EpP1NpEEHjHd9atCpJd2`,
	"workflowNameStyle": `kzW0PCOT_3cK7YDXAYsP`,
	"workflowCategories": `Y94lVqntAEssfSgWhHUu`,
	"input": `FjvnJsJ6pqlsJELj4_Ag`,
	"sharedBanner": `Q30FGCd4ZhDJKuZYOw3x`
};
export default ___CSS_LOADER_EXPORT___;
